export default "/WebApp/dist/assets/fonts/Raleway-SemiBold.ttf";